import actionTypes from '@atom/actions/actionTypes';

export const updateTeamNavigation = data => ({
  type: actionTypes.UPDATE_TEAM_NAVIGATION,
  data,
});
